export enum OPENCLAIM_TYPES {
  SET_DRAFT_ID = '@openClaim/SET_DRAFT_ID',
  SET_ERROR_DRAFT = '@openClaim/SET_ERROR_DRAFT',
  SET_SUCCESS_DRAFT = '@openClaim/SET_SUCCESS_DRAFT',
  RECOVER_DRAFT = '@openClaim/RECOVER_DRAFT',
  SET_RECOVER_DRAFT = '@openClaim/SET_RECOVER_DRAFT',
  SET_CURRENT_STEP = '@openClaim/SET_CURRENT_STEP',
  SET_UNLOCKED_STEPS = '@openClaim/SET_UNLOCKED_STEPS',
  GET_BANKLIST_REQUEST = '@openClaim/GET_BANKLIST_REQUEST',
  SET_DATA_BANKLIST = '@openClaim/SET_DATA_BANKLIST',
  GET_COVERAGELIST_REQUEST = '@openClaim/GET_COVERAGELIST_REQUEST',
  SET_DATA_COVERAGELIST = '@openClaim/SET_DATA_COVERAGELIST',
  GET_USER_FRANCHISE = '@openClaim/GET_USER_FRANCHISE',
  SET_USER_FRANCHISE = '@openClaim/SET_USER_FRANCHISE',
  GET_USER_REQUEST = '@openClaim/GET_USER_REQUEST',
  SET_DATA_USER = '@openClaim/SET_DATA_USER',
  SET_DATA_STEP = '@openClaim/SET_DATA_STEP',
  CLEAR_DATA_STEP = '@openClaim/CLEAR_DATA_STEP',
  SET_STEPS_ARRAY = '@openClaim/SET_STEPS_ARRAY',
  FINISH_DRAFT = '@openClaim/FINISH_DRAFT',
  SET_STATUS = '@openClaim/SET_STATUS',
  SET_FINAL_ID = '@openClaim/SET_FINAL_ID',
  UPLOAD_DOCUMENT = '@openClaim/UPLOAD_DOCUMENT',
  DELETE_DOCUMENT = '@openClaim/DELETE_DOCUMENT',
  SET_DELETE_DOCUMENT = '@openClaim/SET_DELETE_DOCUMENT',
  SET_UPLOAD_DOCUMENT = '@openClaim/SET_UPLOAD_DOCUMENT',
}

export interface OpenClaimState {
  draftId: string | null;
  errorDraft: any;
  successDraft: any;
  currentStep: number;
  unlockedSteps: number;
  stepsArray: number[];
  destiny: 'stay' | 'forward';
  banklist: any;
  coverage: any;
  franchise: any;
  user: any;
  step: any;
  status: string;
  finalId: string;
}

export interface FileUploaded {
  documentId?: string;
  documentName?: string;
  filename: string;
  id: string;
  url?: string;
  urlImage?: string;
  urlDownload?: string;
  error?: boolean;
}

export interface ResponseFilesUploaded {
  errors: FileUploaded[];
  success: FileUploaded[];
}
